// extracted by mini-css-extract-plugin
export default {"bodyMessage":"Subscription_bodyMessage__wyN8u","parentBoxofLoader":"Subscription_parentBoxofLoader__Qyz+P"};